var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 16,
    viewBox: "0 0 42 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3431 0.925709L41.7071 7.28967C42.0976 7.68019 42.0976 8.31336 41.7071 8.70388L35.3431 15.0678C34.9526 15.4584 34.3195 15.4584 33.9289 15.0678C33.5384 14.6773 33.5384 14.0442 33.9289 13.6536L38.5858 8.99678L-7.31201e-07 8.99677L-5.56355e-07 6.99677L38.5858 6.99678L33.9289 2.33992C33.5384 1.9494 33.5384 1.31623 33.9289 0.925709C34.3195 0.535184 34.9526 0.535184 35.3431 0.925709Z",
    fill: "#626D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonarrow);
export default __webpack_public_path__ + "static/media/buttonarrow.368e78c2f6969ff5a796b28ec17f1493.svg";
export { ForwardRef as ReactComponent };